import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Header from 'components/Header/index'
import Footer from 'components/Footer'
import { COLLAPSED_DRAWER, FIXED_DRAWER } from 'constants/ActionTypes'
import { isIOS, isMobile } from 'react-device-detect'
import { renderRoutes } from 'react-router-config'
import { customerRoutes } from 'app/customerRoutes'
import { specialistRoutes } from 'app/specialistRoutes'
import { getLinkguaType } from 'util/checkAuthentication'
import { SystemNotificationList } from '../Linkgua/components/Notifications'
import { adminRoutes } from 'app/adminRoutes'

const routeSets = {
  customer: customerRoutes,
  specialist: specialistRoutes
}

class App extends React.Component {

  render () {
    const {auth, drawerType} = this.props
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer'

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add('ios-mobile-view-height')
    } else if (document.body.classList.contains('ios-mobile-view-height')) {
      document.body.classList.remove('ios-mobile-view-height')
    }

    return (
      <div className={`app-container ${drawerStyle}`}>
        <div className="app-main-container">
          <div className="app-header">
            <Header/>
          </div>

          <main className="app-main-content-wrapper">
            <SystemNotificationList/>
            <div className="app-main-content">
              {renderRoutes(adminRoutes.concat(routeSets[getLinkguaType(auth)]))}
            </div>
            <Footer/>
          </main>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({settings, auth}) => {
  const {drawerType, navigationStyle, horizontalNavPosition} = settings
  const {authUser} = auth
  return {authUser, drawerType, navigationStyle, horizontalNavPosition, auth}
}

const mapDispatchToProps = {}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./app/index.js